import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/blog-posts/`;
const pathById = `${pathBase}:postId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const blogPosts = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  patch: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
} as const;
